<div class="product-gallery" #gallery data-width="100%" data-thumbwidth="135" data-thumbheight="135" data-nav="thumbs" data-allowfullscreen="true" data-autoplay="true">
      <img *ngFor="let i of data" [src]="i.imagem" width="100%" />  
</div>    
  